import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { CartProvider } from "@/contexts/CartContext";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Menu from "@/pages/Menu";
import Cart from "@/pages/Cart";
import Checkout from "@/pages/Checkout";
import OrderConfirmation from "@/pages/OrderConfirmation";
import Contact from "@/pages/Contact";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import Payment from "@/pages/Payment";
import PaymentCallback from "@/pages/PaymentCallback";
import OwnerLogin from "@/pages/OwnerLogin";
import OwnerDashboard from "@/pages/OwnerDashboard";

function App() {
    return (
        <div className="App">
            <CartProvider>
                <BrowserRouter>
                    <Layout>
                        <Routes>
                            <Route path="/" element={<Home />} />
                            <Route path="/menu" element={<Menu />} />
                            <Route path="/cart" element={<Cart />} />
                            <Route path="/checkout" element={<Checkout />} />
                            <Route path="/order/:orderNumber" element={<OrderConfirmation />} />
                            <Route path="/contact" element={<Contact />} />
                            <Route path="/admin/login" element={<AdminLogin />} />
                            <Route path="/admin" element={<AdminDashboard />} />
                            <Route path="/pay/:orderNumber" element={<Payment />} />
                            <Route path="/payment/callback" element={<PaymentCallback />} />
                            <Route path="/owner/login" element={<OwnerLogin />} />
                            <Route path="/owner" element={<OwnerDashboard />} />
                        </Routes>
                    </Layout>
                    <Toaster position="top-center" richColors closeButton dir="rtl" />
                </BrowserRouter>
            </CartProvider>
        </div>
    );
}

export default App;
